import { useEffect, useRef, useState } from "react";

const values = [
  {
    icon: "ri-compass-3-line",
    title: "尋源之旅",
    desc: "我們親赴西藏、雲南、緬甸等地，深入產地，親手挑選每一顆天珠、每一塊礦石，確保材質的天然純正與能量的完整性。",
    color: "#8b6f47",
    bg: "#f5ede0",
  },
  {
    icon: "ri-eye-line",
    title: "嚴格篩選",
    desc: "每一件商品都經過多道嚴格的品質把關，從材質真偽、能量狀態到美感呈現，只有通過所有標準的作品，才能成為瓏靖的一員。",
    color: "#4a7a52",
    bg: "#eaf2eb",
  },
  {
    icon: "ri-heart-3-line",
    title: "手作溫度",
    desc: "每一件飾品都由我們親手設計與製作，融入對東方文化的理解與對佩戴者的祝福，讓每一件作品都有獨一無二的溫度。",
    color: "#7a6a9a",
    bg: "#f0edf7",
  },
  {
    icon: "ri-book-open-line",
    title: "文化傳承",
    desc: "我們不只是販售飾品，更致力於傳遞東方能量文化的知識與智慧，讓更多人了解這份古老傳承的美麗與意義。",
    color: "#c9a96e",
    bg: "#faf5ec",
  },
];

export default function Philosophy() {
  const ref = useRef<HTMLDivElement>(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setVisible(true); },
      { threshold: 0.15 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section className="py-28 md:py-36 bg-[#f5f0e8]" ref={ref}>
      <div className="max-w-7xl mx-auto px-6 md:px-16">
        {/* Header */}
        <div
          className={`text-center mb-16 transition-all duration-1000 ${
            visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"
          }`}
        >
          <div className="flex items-center justify-center gap-3 mb-5">
            <span className="w-10 h-px bg-[#8b6f47]"></span>
            <span
              className="text-[#8b6f47] text-[1rem] tracking-[0.3em] font-medium"
              style={{ fontFamily: "'Noto Serif TC', serif" }}
            >
              OUR PHILOSOPHY
            </span>
            <span className="w-10 h-px bg-[#8b6f47]"></span>
          </div>
          <h2
            className="text-[#2d2520] font-bold mb-5 leading-[1.4]"
            style={{
              fontSize: "clamp(1.5rem, 3vw, 2.125rem)",
              fontFamily: "'Noto Serif TC', serif",
            }}
          >
            創辦理念
          </h2>
          <p
            className="text-[#7a6a5a] max-w-2xl mx-auto leading-[1.75]"
            style={{
              fontSize: "1.1875rem",
              fontFamily: "'Noto Serif TC', serif",
            }}
          >
            我們相信，真正的能量飾品不只是裝飾，更是一份來自天地的祝福與守護。瓏靖的每一個決定，都源自這份初心。
          </p>
        </div>

        {/* Values Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-8">
          {values.map((item, i) => (
            <div
              key={item.title}
              className={`bg-white rounded-2xl p-8 md:p-10 transition-all duration-1000`}
              style={{
                transitionDelay: `${i * 120}ms`,
                opacity: visible ? 1 : 0,
                transform: visible ? "translateY(0)" : "translateY(24px)",
              }}
            >
              <div
                className="w-14 h-14 flex items-center justify-center rounded-2xl mb-6"
                style={{ backgroundColor: item.bg }}
              >
                <i className={`${item.icon} text-2xl`} style={{ color: item.color }}></i>
              </div>
              <h3
                className="text-[#2d2520] font-bold mb-4"
                style={{
                  fontSize: "clamp(1.25rem, 2vw, 1.625rem)",
                  fontFamily: "'Noto Serif TC', serif",
                }}
              >
                {item.title}
              </h3>
              <p
                className="text-[#7a6a5a] leading-[1.75]"
                style={{
                  fontSize: "1.1875rem",
                  fontFamily: "'Noto Serif TC', serif",
                }}
              >
                {item.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
